import { render } from "./cinder.vue?vue&type=template&id=5fcdd1ee"
import script from "./cinder.vue?vue&type=script&lang=js"
export * from "./cinder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__